import React from 'react';
import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { Button } from "reactstrap";
import PlantConfigurationFormLayout from './PlantConfigurationFormLayout';
import axios from "axios";
import Sidebar from '../../Sidebar';
import { useNavigate } from 'react-router';
import { useCookies } from 'react-cookie';
import { useLocation, Link } from 'react-router-dom';
import {displayErrorToast,displayError,parseBoolean} from '../../helpers';
import ErrorToast from '../../ErrorToast';
import { getUserAllowedPlants } from '../../services/PlantServices';
import FloatingControls from '../../components/FloatingControls';
import LoadingOverlay from '../../components/LoadingOverlay';
import { useParams } from 'react-router-dom';
import { updatePlantConfiguration,getPlantConfigurationDetails } from '../../services/PlantConfigurationServices';
import TableRowsPlantConfigEdit from "../../forms/admin/TableRowsPlantConfigEdit";
import PremiumPageHeader from '../../components/PremiumPageHeader';

function PlantConfigurationEdit() {
  const [isChecked, setIsChecked] = useState({})
  const [category] = useCookies(['myCategory']);
  const [error, setError] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(true);
  const [superuser] = useCookies(['mySuperuser']);
  const [cookies] = useCookies(['myToken']);
  const [inProgress, setInProgress] = useState(false);
  const [inputs, setInputs] = useState({});
  const [plants,setPlants] =React.useState([]);
  const [columnNumber,setColumnNumber] = useState({
    "silo_1_no":0,
    "silo_2_no":0,
    "silo_3_no":0,
    "silo_4_no":0,
    "silo_5_no":0,
    "bin_1_no":0,
    "bin_2_no":0,
    "bin_3_no":0,
    "bin_4_no":0,
    "bin_5_no":0,
    "other_1_no": 0,
    "other_2_no":0,
    "other_3_no":0,
    "other_4_no":0,
    "other_5_no":0
  })

  const [rowsData, setRowsData] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const addTableRows = () => {
    const rowsInput={
            id:'',
            header_name:'',
            column_number:0,
            value:'0'
        }
        setRowsData([...rowsData, rowsInput])
  }
    
  const deleteTableRows = (index)=>{
        const rows = [...rowsData];
        rows.splice(index, 1);
        setRowsData(rows);
  }

  const handletableChange = (index, evnt)=>{
    const { name, value } = evnt.target;
    const rowsInput = [...rowsData];
    rowsInput[index][name] = value;
    setRowsData(rowsInput);
  }

  React.useEffect(() => {
    getUserAllowedPlants(cookies)
    .then (
        plantList => {
          // console.log(JSON.stringify(plantList)+"plantList")
          const plant = plantList.plant_list.filter(obj => obj.status).map(
              plant => {
                  return { value: plant.id, label: plant.plant_alias }
              }
          );
          setPlants(plant);
        }
    )
  }, []);

  const {id}=useParams()
  React.useEffect(() => {
    if (id)
    {
      setInProgress(true);
      getPlantConfigurationDetails(cookies, id)
      .then(response => {
          console.log(JSON.stringify(response)+"response")
          setInProgress(false);
          setInputs(values => ({...values,["id"]:response.id,
          ["target_cycle"]:response.target_cycle,
          ["plant_id"]:response.plant.id,
          ["silo_1"]:response.silo_1,
          ["silo_2"]:response.silo_2,
          ["silo_3"]:response.silo_3,
          ["silo_4"]:response.silo_4,
          ["silo_5"]:response.silo_5,
          ["bin_1"]:response.bin_1,
          ["bin_2"]:response.bin_2,
          ["bin_3"]:response.bin_3,
          ["bin_4"]:response.bin_4,
          ["bin_5"]:response.bin_5,
          ["other_1"]:response.other_1,
          ["other_2"]:response.other_2,
          ["other_3"]:response.other_3,
          ["other_4"]:response.other_4,
          ["other_5"]:response.other_5,
          ["show_all_columns"]:response.show_all_columns?'true':'false',
          ["add_extra_columns"]:response.add_extra_columns?'true':'false',
          ["user_remarks"]:response.user_remarks
        }))
        setIsChecked(values => ({...values,
          ["is_silo_1"]:response.is_silo_1,
          ["is_silo_2"]:response.is_silo_2,
          ["is_silo_3"]:response.is_silo_3,
          ["is_silo_4"]:response.is_silo_4,
          ["is_silo_5"]:response.is_silo_5,
          ["is_bin_1"]:response.is_bin_1,
          ["is_bin_2"]:response.is_bin_2,
          ["is_bin_3"]:response.is_bin_3,
          ["is_bin_4"]:response.is_bin_4,
          ["is_bin_5"]:response.is_bin_5,
          ["is_other_1"]:response.is_other_1,
          ["is_other_2"]:response.is_other_2,
          ["is_other_3"]:response.is_other_3,
          ["is_other_4"]:response.is_other_4,
          ["is_other_5"]:response.is_other_5,
          ["is_admix_in_kgs"]:response.is_admix_in_kgs
        }))
        setColumnNumber({
          "silo_1_no":response.silo_1_no,
          "silo_2_no":response.silo_2_no,
          "silo_3_no":response.silo_3_no,
          "silo_4_no":response.silo_4_no,
          "silo_5_no":response.silo_5_no,
          "bin_1_no":response.bin_1_no,
          "bin_2_no":response.bin_2_no,
          "bin_3_no":response.bin_3_no,
          "bin_4_no":response.bin_4_no,
          "bin_5_no":response.bin_5_no,
          "other_1_no":response.other_1_no,
          "other_2_no":response.other_2_no,
          "other_3_no":response.other_3_no,
          "other_4_no":response.other_4_no,
          "other_5_no":response.other_5_no
        })
        setRowsData(response.detail_list)
      })
      .catch(error => {
          setInProgress(false);
          displayError(error.response.data, "Loading Failed");
      });
    }
  }, []);

  const navigate = useNavigate();
  const validate_handle_change = (name, value, chkbox, error_field_name) => {
    console.log(name,value,chkbox,error_field_name+"validate_handle_change")
    let customErrorMessage = error_field_name + " must not be empty if its checkbox is checked."
    setError((values) => ({ ...values, [name]: (chkbox && (!(value.trim()))) ? customErrorMessage : "" }));
  };
  
  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    try{
      if(name === 'silo_1')
      {
        validate_handle_change(name,value,isChecked.is_silo_1,"Silo 1")
      }
      else if(name === 'silo_2')
      {
        validate_handle_change(name,value,isChecked.is_silo_2,"Silo 2")
      }
      else if(name === 'silo_3')
      {
        validate_handle_change(name,value,isChecked.is_silo_3,"Silo 3")
      }
      else if(name === 'silo_4')
      {
        validate_handle_change(name,value,isChecked.is_silo_4,"Silo 4")
      }
      else if(name === 'silo_5')
      {
        validate_handle_change(name,value,isChecked.is_silo_5,"Silo 5")
      }
      else if(name === 'bin_1')
      {
        validate_handle_change(name,value,isChecked.is_bin_1,"Bin 1")
      }
      else if(name === 'bin_2')
      {
        validate_handle_change(name,value,isChecked.is_bin_2,"Bin 2")
      }
      else if(name === 'bin_3')
      {
        validate_handle_change(name,value,isChecked.is_bin_3,"Bin 3")
      }
      else if(name === 'bin_4')
      {
        validate_handle_change(name,value,isChecked.is_bin_4,"Bin 4")
      }
      else if(name === 'bin_5')
      {
        validate_handle_change(name,value,isChecked.is_bin_5,"Bin 5")
      }
      else if(name === 'other_1')
      {
        validate_handle_change(name,value,isChecked.is_other_1,"Other 1")
      }
      else if(name === 'other_2')
      {
        validate_handle_change(name,value,isChecked.is_other_2,"Other 2")
      }
      else if(name === 'other_3')
      {
        validate_handle_change(name,value,isChecked.is_other_3,"Other 3")
      }
      else if(name === 'other_4')
      {
        validate_handle_change(name,value,isChecked.is_other_4,"Other 4")
      }
      else if(name === 'other_5')
      {
        validate_handle_change(name,value,isChecked.is_other_5,"Other 5")
      }
      else if(name === 'add_extra_columns'){
        if(value === 'true'){
          setShowModal(true);
        }
      }
      setInputs(values => ({ ...values, [name]: event.target.value }))
    }
    catch(e)
    {
      displayErrorToast(e);
    } 
  }

  const validate_checkbox = (name, value, input_field,error_field, error_field_name) => {
    console.log(name,value,input_field,error_field,error_field_name+"validate_checkbox ")
    let customErrorMessage = error_field_name + "  must not be empty if its checkbox is checked."
    setError((values) => ({ ...values, [error_field]: (value && (!(input_field.trim()))) ? customErrorMessage : "" }));
  };

  const handleCheckboxes = (event) => {
    try{
    const name = event.target.name;
    const value = event.target.checked;
    console.log(value+name+"name valuecheck")
    if(name === 'is_silo_1')
    {
      validate_checkbox(name,value,inputs.silo_1,"silo_1","Silo 1")
    }
    else  if(name === 'is_silo_2')
    {
      validate_checkbox(name,value,inputs.silo_2,"silo_2","Silo 2")
    }
    else if(name === 'is_silo_3')
    {
      validate_checkbox(name,value,inputs.silo_3,"silo_3","Silo 3")
    }
    else if(name === 'is_silo_4')
    {
      validate_checkbox(name,value,inputs.silo_4,"silo_4","Silo 4")
    }
    else if(name === 'is_silo_5')
    {
      validate_checkbox(name,value,inputs.silo_5,"silo_5","Silo 5")
    }
    else if(name === 'is_bin_1')
    {
      validate_checkbox(name,value,inputs.bin_1,"bin_1","Bin 1")
    }
    else if(name === 'is_bin_2')
    {
      validate_checkbox(name,value,inputs.bin_2,"bin_2","Bin 2")
    }
    else if(name === 'is_bin_3')
    {
      validate_checkbox(name,value,inputs.bin_3,"bin_3","Bin 3")
    }
    else if(name === 'is_bin_4')
    {
      validate_checkbox(name,value,inputs.bin_4,"bin_4","Bin 4")
    }
    else if(name === 'is_bin_5')
    {
      validate_checkbox(name,value,inputs.bin_5,"bin_5","Bin 5")
    }
    else if(name === 'is_other_1')
    {
      validate_checkbox(name,value,inputs.other_1,"other_1","Other 1")
    }
    else if(name === 'is_other_2')
    {
      validate_checkbox(name,value,inputs.other_2,"other_2","Other 2")
    }
    else if(name === 'is_other_3')
    {
      validate_checkbox(name,value,inputs.other_3,"other_3","Other 3")
    }
    else if(name === 'is_other_4')
    {
      validate_checkbox(name,value,inputs.other_4,"other_4","Other 4")
    }
    else if(name === 'is_other_5')
    {
      validate_checkbox(name,value,inputs.other_5,"other_5","Other 5")
    }
    setIsChecked(values => ({...values, [name]: value}))
    }
    catch(e)
    {
      displayErrorToast(e);
    } 
  }

  const handleSubmit=(event)=> {
    event.preventDefault();
    console.log(JSON.stringify(isChecked)+"ischecked submit");
    console.log(JSON.stringify(inputs)+"inputs submit");
    console.log(JSON.stringify(error)+"error  submit");
    console.log(JSON.stringify(rowsData)+rowsData.length+"rowsData");
    console.log(JSON.stringify(columnNumber)+"columnNumber  submit");
    // console.log(isSubmitting+"isSubmitting");
    var column_list = []
    
    // if (inputs.show_all_columns === 'true'){
      Object.keys(isChecked).map(key => {
        if (isChecked[key]){
          console.log(key+"key checked");
          // Extracting the index from the key
          const index = parseInt(key.split("_")[2]);
          const name =key.split("_")[1];

          // Constructing the key for columnNumber
          const columnKey = name+'_'+index+'_no';
          console.log(columnKey+"column key")
            if (parseInt(columnNumber[columnKey]) > 0){
              // setColumnList(prevArray => [...prevArray, parseInt(columnNumber[columnKey])]);
              column_list.push(parseInt(columnNumber[columnKey]))
            }
        }
      })
    var isValid = 1;
    if((inputs.add_extra_columns === 'true')){
      if(rowsData.length == 0){
      // alert("inputs.add_extra_columns === 'true') && (rowsData.length == 0")
        // setIsSubmitting(false);
        isValid = 0;
        Swal.fire('If add extra columns is true then atleast one extra columns must be filled in table.', '', 'info'); 
      }
      else {
       // Iterate over each object in the array
        for (let i = 0; i < rowsData.length; i++) {
        const obj = rowsData[i];
        
        // Check whether the 'header_name' property is  empty
          if (!obj.header_name || obj.header_name.trim() === '') {
            // alert('Header name of extra columns list must not be empty.')
            isValid = 0;
            Swal.fire('Header name of extra columns list must not be empty.', '', 'info') 
            // setIsSubmitting(false); 
          }
          // Check whether the 'column_number' is greater than 0 and less than or equal to 15 plus the array length
          else if ((obj.column_number <= 0) || (obj.column_number > 20)) {
            // alert('column_number  of extra columns list must  be greater than 0 and must not be greater than 20')
            // setIsSubmitting(false);
            isValid = 0;
            Swal.fire('column_number  of extra columns list must  be greater than 0 and must not be greater than 20', '', 'info')  
          }
          else{
            // setIsSubmitting(true)
            // setColumnList(prevArray => [...prevArray, parseInt(obj.column_number)]);
            column_list.push(parseInt(obj.column_number));
          }
        }
      }
    }
    console.log(JSON.stringify(column_list)+"column_list initial");
    const set = new Set();
    for (let item of column_list) {
      // If the item is already in the set, it's a duplicate
      if (set.has(item)) {
        console.log(item+"item");
        Swal.fire(`Duplicates are not allowed.${item}`, '', 'info') 
        isValid=0 
      }
      // Otherwise, add it to the set
      set.add(item);
    }
    const maxNumber = Math.max(...column_list); // Find the maximum number in the array
    for (let i = 1; i < maxNumber; i++) {
      // Check if each number less than the max is present
      if (!column_list.includes(i)) {
        Swal.fire(`Column numbers must be in sequence.${i} is missing`, '', 'info')  // If any number is missing, return false
        isValid = 0;
      }
    }
   
    if ((Object.values(error).every(x => !x))&& (isValid === 1)){
      console.log(JSON.stringify(error)+"erroe Object.values(error).every(x => !x");
      Swal.fire({title: 'Do you want to update?',  
          showCancelButton: true,  
          confirmButtonText: `Yes`,  
          cancelButtonText: `No`,
          }).then((result) => {  
            if (result.isConfirmed) { 
                updatePlantConfiguration(cookies, {
                  id:inputs.id,
                  target_cycle:parseInt(inputs.target_cycle),
                  plant_id:inputs.plant_id,
                  silo_1:inputs.silo_1,
                  is_silo_1:isChecked.is_silo_1,
                  silo_2:inputs.silo_2,
                  is_silo_2:isChecked.is_silo_2,
                  silo_3:inputs.silo_3,
                  is_silo_3:isChecked.is_silo_3,
                  silo_4:inputs.silo_4,
                  is_silo_4:isChecked.is_silo_4,
                  silo_5:inputs.silo_5,
                  is_silo_5:isChecked.is_silo_5,
                  bin_1:inputs.bin_1,
                  is_bin_1:isChecked.is_bin_1,
                  bin_2:inputs.bin_2,
                  is_bin_2:isChecked.is_bin_2,
                  bin_3:inputs.bin_3,
                  is_bin_3:isChecked.is_bin_3,
                  bin_4:inputs.bin_4,
                  is_bin_4:isChecked.is_bin_4,
                  bin_5:inputs.bin_5,
                  is_bin_5:isChecked.is_bin_5,
                  other_1: inputs.other_1,
                  is_other_1:isChecked.is_other_1,
                  other_2:inputs.other_2,
                  is_other_2:isChecked.is_other_2,
                  other_3:inputs.other_3,
                  is_other_3:isChecked.is_other_3,
                  other_4:inputs.other_4,
                  is_other_4:isChecked.is_other_4,
                  other_5:inputs.other_5,
                  is_other_5:isChecked.is_other_5,
                  is_admix_in_kgs:isChecked.is_admix_in_kgs,
                  add_extra_columns:inputs.add_extra_columns?parseBoolean(inputs.add_extra_columns):false,
                  show_all_columns:inputs.show_all_columns?parseBoolean(inputs.show_all_columns):false,
                  user_remarks:inputs.user_remarks,
                  silo_1_no:parseInt(columnNumber.silo_1_no),
                  silo_2_no:parseInt(columnNumber.silo_2_no),
                  silo_3_no:parseInt(columnNumber.silo_3_no),
                  silo_4_no:parseInt(columnNumber.silo_4_no),
                  silo_5_no:parseInt(columnNumber.silo_5_no),
                  bin_1_no:parseInt(columnNumber.bin_1_no),
                  bin_2_no:parseInt(columnNumber.bin_2_no),
                  bin_3_no:parseInt(columnNumber.bin_3_no),
                  bin_4_no:parseInt(columnNumber.bin_4_no),
                  bin_5_no:parseInt(columnNumber.bin_5_no),
                  other_1_no:parseInt(columnNumber.other_1_no),
                  other_2_no:parseInt(columnNumber.other_2_no),
                  other_3_no:parseInt(columnNumber.other_3_no),
                  other_4_no:parseInt(columnNumber.other_4_no),
                  other_5_no:parseInt(columnNumber.other_5_no),
                  detail_list:rowsData.map(q=>({
                    id:q.id,
                    header_name:q.header_name,
                    column_number:parseInt(q.column_number),
                    value:q.value
                  }))
               },id)
              .then(response => {
                  Swal.fire("Updated!", "", "success");
                  view();
              }).catch((error) => {
                  displayError(error.response.data,"Updated Failed");
              });
            } 
            else if (result.isDismissed) 
            {    
              Swal.fire('Not Updated', '', 'info')  
            }
          });
    }
  }

  const Cancel = () => {
    setInputs(() => "")
  }

  const Reload = () => {
    window.location.reload();
  } 

  const view = () => {
    navigate('/PlantConfigurationTable')
  } 

  const Back = () => {
    navigate('/Home')
  }

  const Close = () => {
    setShowModal(false)
  }

  const handleColumnNo =(event) => {
    try {
      const name = event.target.name;
      const value = event.target.value;
      setColumnNumber(values => ({ ...values, [name]: event.target.value }))
    }
    catch(e)
    {
      displayErrorToast(e);
    } 
  }

  return(
    <>
      <div id="outer-container" className="App" >
        <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
        <ErrorToast/>
        <LoadingOverlay inProgress={inProgress}/>
        <div id="page-wrap">
          <form onSubmit={handleSubmit} >
            <div className="premium-page-header-wrap">
              <PremiumPageHeader
                module="ADMIN"
                title="Update Plant Configuration"
                subtitle="Edit plant-level parameters."
                modeLabel="EDIT MODE"
              />
            </div>
            <FloatingControls tableLink="/PlantConfigurationTable" onCancel={Cancel} enableCancel={false}/>
            <div className="container"> 
                <PlantConfigurationFormLayout
                  inputs={inputs}
                  handleChange={handleChange}
                  isChecked={isChecked}
                  handleCheckboxes={handleCheckboxes}
                  columnNumber={columnNumber}
                  handleColumnNo={handleColumnNo}
                  error={error}
                  plants={plants}
                  plantSelectDisabled
                />
                <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel" >
                    <label htmlFor="user_remarks" className="form-group col-sm-2 text-left">Remarks</label>
                    <textarea rows="2" cols="50" className="form-control col-sm-12" id="user_remarks" name="user_remarks" onChange={handleChange} value={inputs.user_remarks || ""}></textarea>
                </div> 
                <div className="modal" tabIndex="-1" style={{ display: showModal ? 'block' : 'none' }}>
                  <div className="modal-dialog modal-xl" style={{height: "500px",width:"500px"}} >
                    <div className="modal-content">
                      <div className="modal-body display">
                        <div className="container item-list-table-container">
                          <table className="table order-list" id="myTable"  style={{textAlign:"center",borderRadius:"10px"}}>
                            <thead>
                              <tr>
                                <th><button className="btn btn-success" onClick={addTableRows} >+</button></th>
                                <th style={{display:"none"}} >Id</th>
                                <th>Header Name</th>
                                <th>Column No</th>
                                <th>Value</th>
                              </tr>
                            </thead>
                            <tbody >
                                <TableRowsPlantConfigEdit rowsData={rowsData} deleteTableRows={deleteTableRows} handletableChange={handletableChange} />
                            </tbody>
                          </table>
                          <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={Close}>Close</button> 
                        </div> 
                      </div>
                    </div>
                  </div>
                </div>           
            </div>

            <div className="footer text-center">
              <Button  type="submit" className="btn btn-twitter" style={{width:"80px",fontWeight:"bold"}} >Update</Button> &nbsp;&nbsp;
              <Button className="btn btn-twitter"  type="button"style={{width:"80px",fontWeight:"bold"}} onClick={view}>View</Button>&nbsp;&nbsp;
              <Button className="btn btn-twitter"  type="button"style={{width:"80px",fontWeight:"bold"}} onClick={Back}>Home</Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
export default PlantConfigurationEdit;